export type Bonus = {
  number: string
  name: string
  summary: string
  pages: string
  value: number
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    name: 'Clinical Screening & Safety Checklists',
    summary:
      'Intake forms, regional precaution checklists, consent documentation, referral templates, and printable safety reference cards.',
    pages: '40 pages of screening forms & safety tools',
    value: 12,
  },
  {
    number: '02',
    name: 'Assessment & Reassessment Toolkit',
    summary:
      'Functional tests for every region, grip and walking assessments, observation forms, and before-and-after comparison charts.',
    pages: '40 pages of assessment & reassessment tools',
    value: 12,
  },
  {
    number: '03',
    name: 'Home Rehabilitation & Patient Exercise Handouts',
    summary:
      'Ready-to-customize home routines for every body region, with illustrations, sets, reps, and weekly schedules.',
    pages: '40 pages including 30 patient handouts',
    value: 15,
  },
  {
    number: '04',
    name: 'Clinical Progression & Return-to-Function Planner',
    summary:
      'Functional progression pathways, loading adjustments, and return-to-daily-activity planning worksheets.',
    pages: '40 pages including 24 progression pathways',
    value: 12,
  },
  {
    number: '05',
    name: 'Clinical Session Builder & Multi-Region Planner',
    summary:
      'Technique index, single- and multi-region planners, and 15- to 60-minute session builders to customize every appointment.',
    pages: '40 pages of session planning tools',
    value: 10,
  },
]

export const pricing = {
  bonusValue: 61,
  price: '26.90',
}

export const checkoutFeatures = [
  '5 Specialized Anatomical Volumes',
  '60 Step-by-Step Soft-Tissue Techniques',
  '40 Complete Clinical Session Templates',
  'Patient Positioning & Hand Placement',
  'Functional Rehabilitation Exercises',
  '5 Professional Bonus Toolkits',
  'Instant Digital Access',
  '7-Day Guarantee',
]
